import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = { class: "col-12 col-md-6" }
const _hoisted_7 = { class: "col-12 text-center" }
const _hoisted_8 = { class: "text-danger text-center" }

import { computed, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import type IPhoneCode from "@/interfaces/IPhoneCode";
import { useVeeField } from "@/composables/useVeeField";
import { buildAccountUpdateSchema } from "@/schemas/account";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import PhoneCodes from "@/utils/PhoneCodes";
import { goBackCanvas } from "@/views/OffcanvasViews/OffcanvasViewsConfig";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountUpdate',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);

const phoneCodes = PhoneCodes;
const phoneCode = ref<IPhoneCode>(PhoneCodes[0]);
const phoneMask = ref("(##) #####-####");
const submitting = ref(false);
const errorMessage = ref("");

const { handleSubmit, meta } = useForm({
  validationSchema: computed(() =>
    toTypedSchema(buildAccountUpdateSchema(phoneCode.value?.mask.length)),
  ),
  initialValues: {
    name: session.value?.name ?? "",
    document_number: session.value?.document_number ?? "",
    country_code: session.value?.country_code ?? "",
    phone: session.value?.phone ?? "",
  },
});

const nameModel = useVeeField("name");
const documentNumberModel = useVeeField("document_number");
const countryCodeModel = useVeeField("country_code");
const phoneModel = useVeeField("phone");

const { mutateAsync: updateUser } = useUpdateUser();

const handleAccountUpdate = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    const params = {
      ...values,
      phone: (values.phone as any).clear(),
      document_number: (values.document_number as any).clear(),
    };
    await updateUser({ id: session.value!.id, ...params });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Informações alteradas",
      msg: "Suas informações foram alteradas com sucesso",
    });
    goBackCanvas();
  } catch (error: any) {
    console.log(error);
    errorMessage.value = error.message;
  } finally {
    submitting.value = false;
  }
});

function countryCodeChanged(value: string) {
  phoneModel.$model = "";
  const pc = phoneCodes.find((e) => e.dial_code === value);
  if (pc) {
    phoneCode.value = pc;
    phoneMask.value = pc.mask || "##########";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TextInput, {
          required: "",
          label: "Nome completo",
          model: _unref(nameModel),
          type: "text",
          placeholder: "Qual seu nome?"
        }, null, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TextInput, {
          required: "",
          label: "CPF",
          model: _unref(documentNumberModel),
          type: "text",
          mask: '###.###.###-##',
          placeholder: "Qual seu CPF?"
        }, null, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_SelectInput, {
          required: "",
          onSelectChanged: countryCodeChanged,
          model: _unref(countryCodeModel),
          options: _unref(phoneCodes),
          label: "DDI",
          propertyForValue: "dial_code",
          propertyForText: "label"
        }, null, 8, ["model", "options"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TextInput, {
          required: "",
          label: "Telefone (Whatsapp)",
          model: _unref(phoneModel),
          type: "text",
          mask: phoneMask.value,
          placeholder: "Qual seu telefone?"
        }, null, 8, ["model", "mask"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(errorMessage.value), 1)
      ])
    ]),
    _createVNode(_component_FormButton, {
      class: "w-100 mt-auto",
      label: "Concluir",
      disabled: !_unref(meta).valid,
      onOnClick: _unref(handleAccountUpdate),
      marginVertical: false,
      loading: submitting.value
    }, null, 8, ["disabled", "onOnClick", "loading"])
  ]))
}
}

})